import DOMPurify from 'dompurify'

interface ProductDescriptionProps {
    description: string
}

export const ProductDescription = ({
    description
}: ProductDescriptionProps) => {
    return (
        <p
            className="line-clamp-3 text-xs font-normal !leading-normal text-neutral-600 md:line-clamp-4 md:text-sm"
            dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(description)
            }}
        />
    )
}
